import React from 'react'
import {Button,Form,FormGroup,Label,Input} from 'reactstrap';

class ProductForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {error: null, values: props.product || {}}
  }

  static getDerivedStateFromProps(props, state) {
    const values = props.product || {}
    if(values && values.id && !state.values.id) {
      return {...state, values: {...values}}
    }
    return null
  }

  handleChange = (e) => {
    e.preventDefault()
    const values = {...this.state.values, [e.target.name]: e.target.value}
    this.setState({values})
  }

  handleSubmit = () => {
    this.setState({isSubmitting: true})
    this.props.submit(this.state.values).then(() =>
      this.setState({values: {}, isSubmitting: false})
    ).catch(error => this.setState({error: error.message,isSubmitting: false}))
  }

  validate = () =>
    this.state.values.name && this.state.values.name.length>0 &&
    this.state.values.description && this.state.values.description.length>0 &&
    this.state.values.price

  render(){
    const Body = this.props.bodyComponent
    const Buttons = this.props.buttonsComponent
    const valid = this.validate()

    return(
      <Form onSubmit={this.handleSubmit}>
        <Body>
          {this.state.error &&
            <p className="text-danger">{this.state.error}</p>
          }
          {this.state.values.number &&
            <FormGroup>
              <Label for="number">Produktnummer</Label>
              <Input
                readOnly
                type="text"
                className="form-control-plaintext"
                defaultValue={this.state.values.number || ''}/>
            </FormGroup>
          }

          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              value={this.state.values.name || ''}
              onChange={this.handleChange}/>
          </FormGroup>

          <FormGroup>
            <Label for="description">Beschreibung</Label>
            <Input
              type="text"
              name="description"
              id="description"
              value={this.state.values.description || ''}
              onChange={this.handleChange}/>
          </FormGroup>

          <FormGroup>
            <Label for="price">Preis</Label>
            <Input
              type="number"
              name="price"
              id="price"
              value={this.state.values.price || 0}
              onChange={this.handleChange}/>
          </FormGroup>
        </Body>

        <Buttons>
          <Button
            color="primary"
            disabled={!valid || this.state.isSubmitting}
            onClick={this.handleSubmit}>
            {this.state.isSubmitting ? 'Bitte Warten...' : 'Speichern'}
          </Button>{' '}
        </Buttons>
      </Form>
    )
  }
}

ProductForm.defaultProps = {
  bodyComponent: React.Fragment,
  buttonsComponent: React.Fragment
};

export default ProductForm



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ProductForm.js